import { Box, styled, Typography } from "@mui/material";
import { formatMoney, MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";

const CartProductContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  textDecoration: "none",
  color: theme.vars.palette.text.primary,
  gap: 12,

  ".product_image_container": {
    position: "relative",
    width: "64px",
    height: "64px",
    flexShrink: 0,

    [theme.breakpoints.down("md")]: {
      width: "56px",
      height: "56px",
    },
  },

  ".product_image": {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },

  ".quantity_badge": {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    backgroundColor: "#000",
    color: "#fff",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: 600,
    border: "2px solid #fff",

    [theme.breakpoints.down("md")]: {
      width: "20px",
      height: "20px",
      fontSize: "11px",
      top: "-4px",
      right: "-4px",
    },
  },

  ".product_detail": {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%",
    justifyContent: "center",

    ".title_price_row": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: 12,
      width: "100%",

      ".name": {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 1.4,
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2,
        color: theme.vars.palette.text.primary,
      },

      ".price": {
        fontSize: 14,
        fontWeight: 600,
        color: theme.vars.palette.text.primary,
        whiteSpace: "nowrap",
        flexShrink: 0,
      },
    },
  },
}));

interface OrderSummaryProductProps {
  product: {
    stacklineSku: string;
    title: string;
    quantity: number;
    retailPrice: number;
    image: string;
  };
}

export const OrderSummaryProduct = ({ product }: OrderSummaryProductProps) => {
  return (
    <CartProductContainer>
      <Box className="product_image_container">
        <img
          className="product_image"
          src={product.image}
          alt={product.title}
          onError={(e) => {
            // e.currentTarget.src = "https://via.placeholder.com/64x64?text=Product";
          }}
        />
        <Box className="quantity_badge">{product.quantity}</Box>
      </Box>
      <Box className="product_detail">
        <Box className="title_price_row">
          <Typography className="name" title={product.title}>
            {product.title}
          </Typography>
          <Typography className="price">
            {formatMoney(product.retailPrice)}
          </Typography>
        </Box>
      </Box>
    </CartProductContainer>
  );
};
